/* ONLY CHASES · buscador desplegable con resultados al momento */
(function () {
  var sp = document.querySelector('[data-oc-sp]');
  if (!sp) return;
  var input = sp.querySelector('[data-oc-sp-input]');
  var body = sp.querySelector('[data-oc-sp-body]');
  var idle = body.innerHTML;
  var url = sp.getAttribute('data-url') + '.json';
  var searchUrl = sp.getAttribute('data-search');
  var timer, ctrl, last = '';
  var money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: sp.getAttribute('data-cur') || 'EUR' });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function full(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

  function open(e) {
    if (e) e.preventDefault();
    sp.hidden = false;
    document.documentElement.classList.add('oc-sp-on');
    requestAnimationFrame(function () { sp.classList.add('is-on'); input.focus(); input.select(); });
  }
  function close() {
    sp.classList.remove('is-on');
    document.documentElement.classList.remove('oc-sp-on');
    setTimeout(function () { sp.hidden = true; }, 180);
  }
  document.querySelectorAll('[data-oc-search-open]').forEach(function (b) { b.addEventListener('click', open); });
  sp.addEventListener('click', function (e) { if (e.target.closest('[data-oc-sp-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sp.hidden) close();
    if (e.key === '/' && sp.hidden && !/input|textarea|select/i.test(document.activeElement.tagName)) open(e);
  });
  body.addEventListener('click', function (e) {
    var c = e.target.closest('[data-q]');
    if (c) { e.preventDefault(); input.value = c.getAttribute('data-q'); run(); input.focus(); }
  });

  function render(q, r) {
    var p = r.products || [], c = r.collections || [], a = r.articles || [];
    if (!p.length && !c.length && !a.length) {
      body.innerHTML = '<div class="oc-sp__none"><p>No encontramos nada con «' + esc(q) + '».</p><p>Prueba con el nombre de la carta, el número (OP17-118) o el set.</p></div>' + idle;
      return;
    }
    var h = '<div class="oc-sp__res">';
    if (p.length) {
      h += '<div><p class="oc-sp__h">Productos</p><ul class="oc-sp__prods">';
      p.forEach(function (x) {
        var price = x.available ? money.format(parseFloat(x.price)) : 'Vendida';
        h += '<li><a href="' + esc(x.url) + '"><span class="oc-sp__img">' + (x.image ? '<img src="' + esc(img(x.image, 120)) + '" alt="" loading="lazy">' : '') + '</span><span class="oc-sp__t"><b>' + esc(x.title) + '</b><small>' + esc(x.vendor || '') + '</small></span><span class="oc-sp__p' + (x.available ? '' : ' is-sold') + '">' + price + '</span></a></li>';
      });
      h += '</ul></div>';
    }
    if (c.length || a.length) {
      h += '<div class="oc-sp__side">';
      if (c.length) { h += '<p class="oc-sp__h">Colecciones</p><ul class="oc-sp__links">'; c.forEach(function (x) { h += '<li><a href="' + esc(x.url) + '">' + esc(x.title) + '</a></li>'; }); h += '</ul>'; }
      if (a.length) { h += '<p class="oc-sp__h">Guías</p><ul class="oc-sp__links">'; a.forEach(function (x) { h += '<li><a href="' + esc(x.url) + '">' + esc(x.title) + '</a></li>'; }); h += '</ul>'; }
      h += '</div>';
    }
    h += '</div><a class="oc-sp__all" href="' + esc(full(q)) + '">Ver todos los resultados de «' + esc(q) + '» <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    body.innerHTML = h;
  }

  function run() {
    var q = input.value.trim();
    if (q === last) return;
    last = q;
    if (ctrl) ctrl.abort();
    if (q.length < 2) { body.innerHTML = idle; sp.classList.remove('is-busy'); return; }
    ctrl = 'AbortController' in window ? new AbortController() : null;
    sp.classList.add('is-busy');
    var u = url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,tag,vendor';
    fetch(u, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      sp.classList.remove('is-busy');
      if (input.value.trim() === q) render(q, (d.resources && d.resources.results) || {});
    }).catch(function () { sp.classList.remove('is-busy'); });
  }
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
})();
